<template>
  <div class="page-wrapper">
    <div class="container-fluid">
      <div class="row">
        <div class="col-6">
          <input type="date" v-model="filter.dateFrom"/>
          <input type="date" v-model="filter.dateTo"/>
        </div>
        <div class="col-6">
          <button type="button" class="btn btn-primary" v-on:click="getVisitors">가져오기</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import {getCategories} from '../api/product'
    import {queryVisits} from "../api/report";

    export default {
        name: "Report",
        data() {
            return {
                filter: {
                    dateFrom:'',
                    dateTo:'',
                    type:'',
                }
            }
        },
        created() {

        },
        mounted() {

        },
        methods: {
            updatePage: function() {

            },
            getVisitors: function() {
                if(this.$data.filter.dateFrom.length == 0 || this.$data.filter.dateFrom === '0000-00-00') {
                    window.alert("Select Date");
                    return;
                }
                if(this.$data.filter.dateTo.length == 0 || this.$data.filter.dateTo === '0000-00-00') {
                    window.alert("Select Date");
                    return;
                }
                let condition = 'from=' + this.$data.filter.dateFrom + '&to=' + this.$data.filter.dateTo;
                queryVisits(condition)
                .then(function(data) {
                    console.log(data)
                    if(data.success) {

                    }
                })
                .catch(function(err) {

                })
            },
            populateVisitorRecord(list) {
                this.$data.visitors.products = [];
                for(let i = 0 ; i < list.length ; i++) {

                    if(list[i].type === 'product') {
                        let found = false;
                        for(let p = 0 ; p < this.$data.visitors.products.length ; p++) {
                            if(this.$data.visitors.products[p].productId == list[i].productId) {
                                this.$data.visitors.products[p].list.push(list[i]);
                                found = true;
                                break;
                            }
                        }
                        if(found == false) {
                            let product = {
                                productId: list[i].productId,
                                title: list[i].title,
                                list:[]
                            }
                            product.list.push(list[i]);
                            this.$data.visitors.products.push(product);
                        }
                    } else if(list[i].type === 'category') {
                        let found = false;
                        for(let p = 0 ; p < this.$data.visitors.categories.length ; p++) {
                            if(this.$data.visitors.categories[p].categoryId == list[i].productId) {
                                this.$data.visitors.categories[p].list.push(list[i]);
                                found = true;
                                break;
                            }
                        }
                        if(found == false) {
                            let category = {
                                categoryId: list[i].productId,
                                title: list[i].title,
                                list:[]
                            }
                            category.list.push(list[i]);
                            this.$data.visitors.categories.push(category);
                        }
                    }
                }
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Report.vue